<template>
  <el-row>
    <div :style="{ width: labelWidth + 'px' }" class="field-label-panel">
      <label class="search-field-label" v-if="label">{{ label }}：</label>
    </div>
    <div
      :style="{ width: `calc(100% - ${this.labelWidth + 30}px)` }"
      class="field-input-panel"
    >
      <eco-input
        v-if="type == 'text'"
        v-model="data"
        :placeholder="placeholder"
        @keyup.enter.native="$emit('enter-search')"
      ></eco-input>
      <eip-org-selector
        v-if="type == 'org-selector'"
        v-model="data"
        :placeholder="placeholder"
        @keyup.enter.native="$emit('enter-search')"
        :single="single"
      >
        <span slot="labeldesc">{{ orgName }}</span>
      </eip-org-selector>
      <eco-date
        v-if="type == 'date'"
        v-model="data"
        :value-format="valueFormat"
        :format="valueFormat"
        :inputFormat="valueFormat"
        :placeholder="placeholder"
        @keyup.enter.native="$emit('enter-search')"
      />
      <eip-dic
        v-if="type == 'dic'"
        v-model="data"
        :dickey="dickey"
        :filterable="false"
        :placeholder="placeholder"
        @keyup.enter.native="$emit('enter-search')"
      />
      <el-date-picker
        v-if="type == 'daterange'"
        v-model="data"
        type="daterange"
        value-format="yyyy-MM-dd"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
      ></el-date-picker>
      <eco-select
        v-if="type == 'select'"
        v-model="data"
        :placeholder="placeholder"
        :options="options"
      ></eco-select>
      <el-select
        v-model="data"
        placeholder="请选择"
        v-if="type === 'option'"
        style="width: 100%"
      >
        <el-option
          v-for="item in options"
          :key="item.index"
          :label="item.value"
          :value="item.value"
        >
          <span
            style="float: left; color: #8492a6; font-size: 13px; margin-right: 10px"
            >{{ item.no }}</span
          >
          <span style="float: left">{{ item.value }}</span>
        </el-option>
      </el-select>
    </div>
  </el-row>
</template>
<script>
export default {
  name: "eco-table-search-field",
  props: {
    prop: {
      type: String,
      required: true
    },
    operation: {
      type: String,
      default: "LIKE",
      validator: value =>
        [
          "EQUAL",
          "EQUAL_IGNORE_CASE",
          "LESS",
          "GREAT",
          "LESS_EQUAL",
          "GREAT_EQUAL",
          "NOT_EQUAL",
          "LIKE",
          "LEFT_LIKE",
          "RIGHT_LIKE",
          "IS_NULL",
          "NOTNULL",
          "IN",
          "BETWEEN"
        ].indexOf(value) != -1
    },
    relation: {
      type: String,
      default: "AND",
      validator: value => ["AND", "OR"].indexOf(value) != -1
    },
    label: String,
    labelWidth: Number,
    type: {
      type: String,
      default: "text",
      validator: value =>
        [
          "text",
          "date",
          "daterange",
          "select",
          "org-selector",
          "option"
        ].indexOf(value) != -1
    },
    options: Array,
    placeholder: {
      type: String,
      default() {
        return `请输入${this.label}`;
      }
    },
    valueFormat: {
      type: String,
      default: ""
    },
    orgName: {
      type: String,
      default: ""
    },
    dickey: {
      type: String,
      default: ""
    },
    single: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      data: null,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  mounted() {
    // 挂载完成后，将本实例注册到高级搜索面板对应的搜索条件列表中
    this.$emit("field-loaded", this);
    this.$watch("data", (newVal, o) => {
      if (newVal !== o) {
        let n = "";
        //如果是日期范围筛选的，把截止日期延后一天，以免截止日期当天查询不到
        if (
          this.type == "daterange" &&
          newVal.constructor == Array &&
          newVal.length == 2
        ) {
          n = JSON.parse(JSON.stringify(newVal));
          n[1] = new Date(
            new Date(n[1]).getTime() + 24 * 60 * 60 * 1000
          ).format("yyyy-MM-dd");
        } else {
          n = newVal;
        }
        this.$emit(
          "input-change",
          { value: n, operation: this.operation, relation: this.relation },
          this.prop
        );
      }
    });
  }
};
</script>
<style lang="stylus" scoped>
.field-label-panel, .field-input-panel {
  display: inline-block;
}

.field-input-panel {
  max-width: 500px;
}

.field-input-panel > .inputs {
  display: block;
}

.field-input-panel > .inputs >>> .el-input__inner {
  border-radius: 0;
}

.search-field-label {
  line-height: 32px;
}

>>> .el-date-editor.el-input {
  width: 100%;
}
</style>
